import React from 'react';

import { Collapse } from 'antd';

import SolicitacaoForm from '../forms';

function callback(key) {
  console.log(key);
}

const { Panel } = Collapse;

export default function ListModelAtendimentos({ text, atendimentos }) {
  return (
    <div syle={{ marginTop: '50px!important' }}>
      <br />
      <h4 syle={{ marginBottom: '50px!important' }}>{text}</h4>
      <Collapse onChange={callback}>
        {atendimentos.map((atendimento) => (
          <Panel
            header={`Atendimento - ${atendimento.numero}`}
            key={atendimento.id}
          >
            <SolicitacaoForm
              initialValues={{ ...atendimento }}
              viewMode
              disableButtons
            />
          </Panel>
        ))}
      </Collapse>
    </div>
  );
}
